import React, { useState } from "react";
import Helmet from "react-helmet";
import { AppName, CleanMessage } from "../../../../util/app";
import DatePicker from "react-datepicker";
import { useMutation } from "react-apollo";
import { REVIEW_PLAN } from "../../../../queries/care-plan.query";
import { toast } from "react-toastify";
import LoadingSpinner from "../../../../partials/loading";
import Editor from "../../../../partials/Editor";

const ReviewPlan = ({ item, onCancel }) => {
    const title = "Careplan Review";

    const [model, setModel] = useState({
        ...item,
        evaluation: {
            ...item.evaluation,
            nextDate: new Date(item.evaluation.nextDate),
        },
    });

    const [reviewFunc, { loading }] = useMutation(REVIEW_PLAN, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            const { message } = d.ReviewCarePlan;
            toast.success(message);
            onCancel();
        },
    });

    return (
        <>
            <Helmet>
                <title>
                    {title} | {AppName}
                </title>
            </Helmet>

            <form
                onSubmit={async (ev) => {
                    ev.preventDefault();
                    await reviewFunc({
                        variables: {
                            id: item.id,
                            update: {
                                intervention: model.intervention,
                                evidence: model.evidence,
                                patientComment: model.patientComment,
                                nextDate: model.evaluation.nextDate,
                                evaluation: model.evaluation.evaluation,
                            },
                        },
                    });
                }}
            >
                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>Plan Detail</h5>
                    </div>
                    <div className="col-12">
                        <table className="table table-bordered">
                            <tbody>
                                <tr>
                                    <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                        <strong>Intervention*</strong>
                                    </td>
                                    <td>
                                        <div className="col-md-12">
                                            <Editor
                                                onChange={(_ev) =>
                                                    setModel({
                                                        ...model,
                                                        intervention: _ev,
                                                    })
                                                }
                                                content={model.intervention}
                                                height={250}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                        <strong>Evidence/Research for Intervention*</strong>
                                    </td>
                                    <td>
                                        <div className="col-md-12">
                                            <textarea
                                                onChange={({ currentTarget }) =>
                                                    setModel({
                                                        ...model,
                                                        evidence: currentTarget.value,
                                                    })
                                                }
                                                defaultValue={model.evidence}
                                                name="evidence-id"
                                                id="evidence-id"
                                                className="form-control form-control-textarea"
                                                rows="4"
                                                placeholder="enter evidence"
                                            ></textarea>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                        <strong>Patient Comment / Evidence of involvement in forming this plan*</strong>
                                    </td>
                                    <td>
                                        <div className="col-md-12">
                                            <input
                                                onChange={({ currentTarget }) =>
                                                    setModel({
                                                        ...model,
                                                        patientComment: currentTarget.value,
                                                    })
                                                }
                                                defaultValue={model.patientComment}
                                                type="text"
                                                className="form-control input-height"
                                                placeholder="enter patient comment ..."
                                                id="Comment-id"
                                                required
                                                aria-describedby="Comment-id"
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>Evaluation!</h5>
                    </div>
                    <div className="col-12">
                        <table className="table table-bordered">
                            <tbody>
                                <tr>
                                    <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                        <strong>Next Evaluation Alert Date*</strong>
                                    </td>
                                    <td>
                                        <div className="col-12">
                                            <DatePicker
                                                onChange={(date) =>
                                                    setModel({
                                                        ...model,
                                                        evaluation: {
                                                            ...model.evaluation,
                                                            nextDate: date,
                                                        },
                                                    })
                                                }
                                                selected={model.evaluation.nextDate}
                                                className="form-control input-height"
                                                timeIntervals={5}
                                                showTimeSelect
                                                timeCaption="Time"
                                                dateFormat="MMMM d, yyyy h:mm aa"
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                        <strong>Evaluation (Please detail of the patient involvement in the evaluation)*</strong>
                                    </td>
                                    <td>
                                        <div className="col-12">
                                            <Editor
                                                onChange={(_ev) =>
                                                    setModel({
                                                        ...model,
                                                        evaluation: {
                                                            ...model.evaluation,
                                                            evaluation: _ev,
                                                        },
                                                    })
                                                }
                                                content={model.evaluation.evaluation}
                                                height={250}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="form-group text-center mt-5">
                    <LoadingSpinner loading={loading} />
                    <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-right-10 btn-circle btn-success">
                        Updated Plan <i className="material-icons">arrow_right_alt</i>
                    </button>
                    <button type="button" onClick={onCancel} className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-left-10 btn-circle btn-default">
                        <i className="material-icons text-danger">cancel</i> Cancel
                    </button>
                </div>
            </form>
        </>
    );
};

export default ReviewPlan;
